import axios from 'axios';
import { eventBus } from '../bus/eventBus';
import { refreshCatalog } from './productCache';
import { listPendingOrders, removePendingOrder } from './pendingOrders';
import { API_BASE_URL } from '../api';

let syncing = false;

// Emits 'offlineSyncStatus' with { syncing, pendingCount } so any component
// (the header indicator, the cart) can reflect progress without polling.
async function notifyStatus(extra = {}) {
    const pending = await listPendingOrders();
    eventBus.emit('offlineSyncStatus', { syncing, pendingCount: pending.length, ...extra });
}

// Replays queued offline sales one at a time, oldest first, stopping at the
// first failure so a still-flaky connection doesn't reorder or drop sales —
// whatever's left just retries on the next sync pass.
async function flushPendingOrders() {
    const pending = await listPendingOrders();
    let synced = 0;

    for (const order of pending) {
        try {
            await axios.post(`${API_BASE_URL}/api/v1/createOrder`, order.requestData, { withCredentials: true });
            await removePendingOrder(order.localId);
            synced++;
        } catch (e) {
            console.error('Failed to sync offline order, will retry later', e);
            break;
        }
    }

    return synced;
}

export async function syncNow() {
    if (syncing) return;
    syncing = true;
    await notifyStatus();

    try {
        const synced = await flushPendingOrders();
        await refreshCatalog();
        if (synced > 0) {
            eventBus.emit('offlineOrdersSynced', { count: synced });
        }
    } catch (e) {
        console.error('Offline sync failed', e);
    } finally {
        syncing = false;
        await notifyStatus();
    }
}

export function initOfflineSync() {
    window.addEventListener('online', syncNow);
    if (navigator.onLine) syncNow();
    return () => window.removeEventListener('online', syncNow);
}
